import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'
import Matt from '../img/matt.png'
import Reflektierend from '../img/reflektierend.png'

function SurfaceRadio({ className, displayErrors }) {

  const { Surfaces, selectedSurface, setSelectedSurface, surfaceIsValid } = ComponentData()

  return (
    <Col md={12}>
      <div className={className}>
        <Row className="headline_texts">
          <div className="configuration-text">
            <p>Bestimmt thermische Aufnahme bei IR</p>
            <h3>Oberfläche</h3>
          </div>
        </Row>
        {Surfaces.map((surface) => {
          return (
            <label className={displayErrors && !surfaceIsValid ? "big_label error" : "big_label"} key={"radio- " + surface}>
              <input
                type="radio"
                name={surface}
                checked={selectedSurface === surface}
                onChange={(e) => { setSelectedSurface(e.target.value) }}
                className={'radio-surface ' + surface}
                value={surface}
              />
              <div >
                <span className='surface-label'>{surface}</span>
                <img className='surface-img' src={surface === 'Matt' ? Matt : Reflektierend} alt='' />
              </div>

            </label>
          )
        })}
        {displayErrors && !surfaceIsValid ? <p className='error'>Oberfläche muss ausgewählt werden!</p> : null}
      </div>
    </Col>
  )
}

export default SurfaceRadio